import { ref, onMounted } from 'vue';

export const useSound = (url: string) => {
  const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
  const audioBuffer = ref<AudioBuffer | null>(null);
  const loopSource = ref<AudioBufferSourceNode | null>(null);

  const preload = async () => {
    const response = await fetch(url);
    const arrayBuffer = await response.arrayBuffer();
    audioBuffer.value = await audioContext.decodeAudioData(arrayBuffer);
  };

  const play = () => {
    if (!audioBuffer.value) return;

    const source = audioContext.createBufferSource();
    source.buffer = audioBuffer.value;
    source.connect(audioContext.destination);
    source.start();
  };

  const startLoop = () => {
    if (!audioBuffer.value) return;
    if (loopSource.value) return;

    const source = audioContext.createBufferSource();
    source.buffer = audioBuffer.value;
    source.loop = true;
    source.connect(audioContext.destination);
    source.start();

    loopSource.value = source;
  };

  const stopLoop = () => {
    if (!loopSource.value) return;

    loopSource.value.stop();
    loopSource.value.disconnect();
    loopSource.value = null;
  };

  onMounted(preload);

  return {
    play,
    startLoop,
    stopLoop,
  };
};
